import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { EssTranslationService } from 'ngx-essentia';
import { NGXLogger as LoggerService } from "ngx-logger";

@Injectable({ providedIn: 'root' })
/**
 * TranslationResolver is an Angular route resolver that ensures translation scopes
 * specified in the route's data are loaded before the route is activated.
 *
 * Usage:
 * - Add `translationScopes` as an array of translation scope names to your route's data.
 * - The resolver will load all specified scopes using EssTranslationService before navigation.
 *
 * Example:
 * {
 *   path: 'some-path',
 *   component: SomeComponent,
 *   resolve: { translations: TranslationResolver },
 *   data: { translationScopes: ['common', 'feature', 'themes] }
 * }
 */
export class TranslationResolver implements Resolve<any> {
    constructor(
        private essTrans: EssTranslationService,
        private logger: LoggerService,
    ) { }

    resolve(route: ActivatedRouteSnapshot): Promise<any> {
        let translationScopes = route.data['translationScopes']
        if (!translationScopes || !Array.isArray(translationScopes)) return
        const loadPromises = translationScopes.map(scope => this.essTrans.load(scope));
        return Promise.all(loadPromises);
    }
}
